import { render, staticRenderFns } from "./IconPoi.vue?vue&type=template&id=e577b5ec&"
import script from "./IconPoi.vue?vue&type=script&lang=js&"
export * from "./IconPoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports